/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TUpdateFolderModel,
  IUpdateFolderRequest,
  IMappers,
  IUpdateFolderResponse,
  IUpdateFolderResponseError,
  TUpdateFolderResponse,
} from './types';

const defaultConfig: TUpdateFolderModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'favorites',
  pathApi: '/v1/update-folder/',
  hostType: 'api',
} as TUpdateFolderModel;

function createUpdateFolderModel(parameters: IUpdateFolderRequest): TUpdateFolderModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IUpdateFolderOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IUpdateFolderRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchUpdateFolder<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IUpdateFolderOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TUpdateFolderResponse> {
  const { response, statusCode } = await httpApi.fetch(createUpdateFolderModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IUpdateFolderResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IUpdateFolderResponseError);
    }
  }

  return { response, statusCode } as TUpdateFolderResponse;
}

export { defaultConfig, createUpdateFolderModel, fetchUpdateFolder };
